<ngb-toast [autohide]="false" (hidden)="onToastHidden()">
    <ng-template ngbToastHeader>
        <!-- <img src="assets/images/logo-sm.png" alt="" class="me-2" height="18"> -->
        <span class="fw-semibold me-auto">{{title}}</span>
        <!-- <small>06 mins ago</small> -->
    </ng-template>
    {{text}}
    <div class="progress">
        <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="75"
            aria-valuemin="0" aria-valuemax="100" style="width: 75%"
            [ngStyle]="{'width': percentage>0?percentage+'%':'100%'}">
        </div>
    </div>
</ngb-toast>